import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { AuthGuardService } from '../authentication/auth-guard.service';

import { DefaultTaskModule } from './default-task/default-task.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule, MatTooltipModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatButtonModule, 
  MatSlideToggleModule, MatIconModule, MatTabsModule, MatDividerModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiSelectModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'app/shared/shared.module';
import { AddOrganizationComponent } from 'app/shared/common/add-organization/add-organization.component';
import { AddLocationComponent } from 'app/shared/common/add-location/add-location.component';
import { DesktopAppComponent } from 'app/shared/common/desktop-app/desktop-app.component';
import { DesktopAppsComponent } from './desktop-apps/desktop-apps.component';
const routes: Routes = [
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService]}
];

@NgModule({
  declarations: [SettingsComponent, DesktopAppsComponent],
  imports: [
    CommonModule,
    MatGridListModule,
    DefaultTaskModule,
    RouterModule.forChild(routes),
    NgxChartsModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    TableModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTabsModule,
    MatDividerModule,
    MultiSelectModule,
    SharedModule
  ],
  entryComponents: [AddOrganizationComponent, AddLocationComponent]
})
export class SettingModule { }
